import React from 'react';
export const Hero = () => {
  return <section id="home" className="pt-24 pb-16 md:py-32" data-id="element-128">
      <div className="container mx-auto px-4" data-id="element-129">
        <div className="flex flex-col md:flex-row items-center" data-id="element-130">
          <div className="w-full md:w-1/2 mb-8 md:mb-0 md:pr-8" data-id="element-131">
            <h2 className="text-3xl md:text-5xl font-light text-stone-800 mb-6" data-id="element-132">
              <span className="block" data-id="element-133">你好呀！</span>
              <span className="block mt-2" data-id="element-134">我是 Grizzyly</span>
            </h2>
            <p className="text-lg md:text-xl text-stone-600 mb-8 leading-relaxed" data-id="element-135">
              一个普通的程序员；有一只叫小九的猫；
            </p>
            <div className="flex space-x-4" data-id="element-136">
              <a href="#contact" className="px-6 py-3 bg-red-700 hover:bg-red-800 text-white rounded-md transition-colors duration-300" data-id="element-137">
                联 系 我
              </a>
              <a href="#projects" className="px-6 py-3 border border-indigo-900 text-indigo-900 hover:bg-indigo-900 hover:text-white rounded-md transition-colors duration-300" data-id="element-138">
                作 品 集
              </a>
            </div>
          </div>
          <div className="w-full md:w-1/2 relative" data-id="element-139">
            <div className="aspect-square max-w-md mx-auto relative" data-id="element-140">
              <div className="absolute inset-0 bg-indigo-900/10 rounded-3xl transform rotate-6" data-id="element-141"></div>
              <img src="https://panxiaoanblog.oss-cn-shenzhen.aliyuncs.com/img/image-20250803213000461.png" alt="Japanese garden with cherry blossoms" className="rounded-3xl object-cover w-full h-full relative z-10 shadow-lg" data-id="element-142" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};